import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from '../utils/axiosConfig';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ArrowLeft, Clock, Loader2, Play } from 'lucide-react';

const API = '/api';

const EstacoesEspecialidade = () => {
  const { especialidadeId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [especialidade, setEspecialidade] = useState(null);
  const [estacoes, setEstacoes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [especialidadeId]);

  const fetchData = async () => {
    try {
      console.log('[ESTACOES] Fetching for especialidade:', especialidadeId);
      
      // Fetch especialidade details
      const espResponse = await axios.get(`${API}/especialidades`);
      const esp = espResponse.data.find(e => e.id === especialidadeId);
      setEspecialidade(esp);
      
      console.log('[ESTACOES] Especialidade:', esp?.nome);

      // Fetch estacoes for this especialidade
      const estacoesResponse = await axios.get(`${API}/estacoes?especialidadeId=${especialidadeId}`);
      console.log('[ESTACOES] Loaded:', estacoesResponse.data.length);
      setEstacoes(estacoesResponse.data);
    } catch (error) {
      console.error('[ESTACOES] Error:', {
        status: error.response?.status,
        message: error.response?.data?.detail || error.message
      });
      toast.error('Erro ao carregar estações');
    } finally {
      setLoading(false);
    }
  };

  const handleIniciarSessao = (estacao) => {
    // For now, just show a message
    // You can implement session creation here
    toast.info(`Funcionalidade de iniciar sessão em desenvolvimento para: ${estacao.nome}`);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#191919] text-white flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto mb-2" />
          <p>Carregando estações...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#191919] text-white">
      {/* Header */}
      <div className="border-b border-gray-800">
        <div className="container mx-auto px-4 py-4">
          <Button
            onClick={() => navigate('/usuario')}
            variant="ghost"
            className="text-gray-400 hover:text-white mb-2"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
          <div>
            <h1 className="text-2xl font-bold">
              {especialidade?.nome || 'Especialidade'}
            </h1>
            <p className="text-gray-400 text-sm mt-1">
              Estações disponíveis para treinar
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        {estacoes.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">
              Nenhuma estação disponível para esta especialidade ainda
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {estacoes.map((estacao) => (
              <Card
                key={estacao.id}
                className="bg-[#0f0f0f] border-gray-800 hover:border-gray-700 transition-all"
              >
                <CardHeader>
                  <CardTitle className="text-white flex items-start justify-between">
                    <span className="pr-2">{estacao.nome}</span>
                    {estacao.ordem && (
                      <span className="text-xs bg-gray-700 px-2 py-1 rounded flex-shrink-0">
                        #{estacao.ordem}
                      </span>
                    )}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-gray-400 text-sm line-clamp-2">
                    {estacao.descricaoCurta || 'Descrição não disponível'}
                  </p>
                  
                  {estacao.tempoMaximoMinutos && (
                    <div className="flex items-center gap-2 text-sm text-gray-400">
                      <Clock className="w-4 h-4" />
                      <span>{estacao.tempoMaximoMinutos} minutos</span>
                    </div>
                  )}

                  <Button
                    onClick={() => handleIniciarSessao(estacao)}
                    className="w-full bg-[#CF0D1D] hover:bg-[#A00A17] text-white"
                  >
                    <Play className="w-4 h-4 mr-2" />
                    Iniciar Sessão
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EstacoesEspecialidade;
